export default __webpack_public_path__ + "static/media/KZ.T.15.0798.2d044414.svg";